$bog_bzrl_app_benefit $mol_view
	sub /
		<= Icon $mol_view
			sub /
				<= icon null
		<= Title $mol_paragraph
			title <= title \
		<= Description $mol_paragraph
			title <= description \

$bog_bzrl_app_benefit_owners $bog_bzrl_app_benefit
	icon <= Icon_owners $mol_icon_home_account
	title @ \owners only
	description @ \No brokers or chains

$bog_bzrl_app_benefit_verified $bog_bzrl_app_benefit
	icon <= Icon_verified $mol_icon_magnify
	title @ \manual verification
	description @ \Listings and landlords are verified by us

$bog_bzrl_app_benefit_secure $bog_bzrl_app_benefit
	icon <= Icon_secure $mol_icon_lock_outline
	title @ \data security
	description @ \Decentralized storage and encryption
